// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* index.css */

/* Reset some default browser styles */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

/* Set a base font size and family */
body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  font-size: 16px;
  line-height: 1.5;
  background-color: #f5f5f5;
  color: #333;
}

/* Make the root container take up the full height */
#root {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

/* Styling for headers */
h1, h2, h3, h4, h5, h6 {
  font-weight: 600;
  margin-bottom: 0.5rem;
  color: #222;
}

/* Add some spacing to paragraphs */
p {
  margin-bottom: 1rem;
}

/* Default button styling */
button {
  font-family: inherit;
  font-size: inherit;
  cursor: pointer;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  background-color: #1976d2;
  color: #fff;
  transition: background-color 0.3s;
}

button:hover {
  background-color: #155fa0;
}

/* Link styles */
a {
  color: #1976d2;
  text-decoration: none;
}

a:hover {
  text-decoration: underline;
}

/* Form input styles */
input, textarea, select {
  width: 100%;
  padding: 0.5rem;
  border: 1px solid #ccc;
  border-radius: 4px;
  margin-bottom: 1rem;
  font-size: 1rem;
}

/* Flex utility class */
.flex {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

/* Utility class for spacing */
.mt-1 {
  margin-top: 1rem;
}

.mb-1 {
  margin-bottom: 1rem;
}

/* Utility class for container padding */
.container {
  padding: 1rem;
  max-width: 1200px;
  margin: 0 auto;
}

/* Default card style */
.card {
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  padding: 1.5rem;
  margin-bottom: 1.5rem;
}

/* Button container styles */
.button-container {
  display: flex;
  justify-content: flex-end;
}

.button-container button {
  margin-left: 0.5rem;
}

/* Table styles */
table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 1rem;
}

table th, table td {
  padding: 0.75rem;
  text-align: left;
  border-bottom: 1px solid #ddd;
}

table th {
  background-color: #f5f5f5;
}

table tr:hover {
  background-color: #f1f1f1;
}

/* Footer styling */
footer {
  padding: 1rem;
  text-align: center;
  background-color: #1976d2;
  color: #fff;
  margin-top: auto;
}

/* Add To Home Screen Button */
.a2hs-button {
  position: fixed;
  bottom: 20px;
  right: 20px;
  padding: 12px 24px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  cursor: pointer;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  transition: background-color 0.3s ease;
}

.a2hs-button:hover {
  background-color: #0056b3;
}

`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA,cAAc;;AAEd,sCAAsC;AACtC;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA,oCAAoC;AACpC;EACE,uGAAuG;EACvG,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,WAAW;AACb;;AAEA,oDAAoD;AACpD;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA,wBAAwB;AACxB;EACE,gBAAgB;EAChB,qBAAqB;EACrB,WAAW;AACb;;AAEA,mCAAmC;AACnC;EACE,mBAAmB;AACrB;;AAEA,2BAA2B;AAC3B;EACE,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,gBAAgB;AAChB;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,sBAAsB;AACtB;EACE,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA,8BAA8B;AAC9B;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,wCAAwC;AACxC;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA,uBAAuB;AACvB;EACE,sBAAsB;EACtB,kBAAkB;EAClB,wCAAwC;EACxC,eAAe;EACf,qBAAqB;AACvB;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,gBAAgB;AAClB;;AAEA,8BAA8B;AAC9B;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,wCAAwC;EACxC,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":["/* index.css */\n\n/* Reset some default browser styles */\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\n/* Set a base font size and family */\nbody {\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;\n  font-size: 16px;\n  line-height: 1.5;\n  background-color: #f5f5f5;\n  color: #333;\n}\n\n/* Make the root container take up the full height */\n#root {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n}\n\n/* Styling for headers */\nh1, h2, h3, h4, h5, h6 {\n  font-weight: 600;\n  margin-bottom: 0.5rem;\n  color: #222;\n}\n\n/* Add some spacing to paragraphs */\np {\n  margin-bottom: 1rem;\n}\n\n/* Default button styling */\nbutton {\n  font-family: inherit;\n  font-size: inherit;\n  cursor: pointer;\n  border: none;\n  padding: 0.5rem 1rem;\n  border-radius: 4px;\n  background-color: #1976d2;\n  color: #fff;\n  transition: background-color 0.3s;\n}\n\nbutton:hover {\n  background-color: #155fa0;\n}\n\n/* Link styles */\na {\n  color: #1976d2;\n  text-decoration: none;\n}\n\na:hover {\n  text-decoration: underline;\n}\n\n/* Form input styles */\ninput, textarea, select {\n  width: 100%;\n  padding: 0.5rem;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  margin-bottom: 1rem;\n  font-size: 1rem;\n}\n\n/* Flex utility class */\n.flex {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n/* Utility class for spacing */\n.mt-1 {\n  margin-top: 1rem;\n}\n\n.mb-1 {\n  margin-bottom: 1rem;\n}\n\n/* Utility class for container padding */\n.container {\n  padding: 1rem;\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n/* Default card style */\n.card {\n  background-color: #fff;\n  border-radius: 8px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  padding: 1.5rem;\n  margin-bottom: 1.5rem;\n}\n\n/* Button container styles */\n.button-container {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.button-container button {\n  margin-left: 0.5rem;\n}\n\n/* Table styles */\ntable {\n  width: 100%;\n  border-collapse: collapse;\n  margin-top: 1rem;\n}\n\ntable th, table td {\n  padding: 0.75rem;\n  text-align: left;\n  border-bottom: 1px solid #ddd;\n}\n\ntable th {\n  background-color: #f5f5f5;\n}\n\ntable tr:hover {\n  background-color: #f1f1f1;\n}\n\n/* Footer styling */\nfooter {\n  padding: 1rem;\n  text-align: center;\n  background-color: #1976d2;\n  color: #fff;\n  margin-top: auto;\n}\n\n/* Add To Home Screen Button */\n.a2hs-button {\n  position: fixed;\n  bottom: 20px;\n  right: 20px;\n  padding: 12px 24px;\n  background-color: #007bff;\n  color: white;\n  border: none;\n  border-radius: 8px;\n  font-size: 16px;\n  cursor: pointer;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  transition: background-color 0.3s ease;\n}\n\n.a2hs-button:hover {\n  background-color: #0056b3;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
